export const getPageIdFromPathName = (pathName: string): string =>
  pathName.replace(/[^A-Za-z1-9|^_]/g, '')
